define({
    root: {
        forwardLabel: '>',
        forwardLabelAria: 'Next'
    }
});
